import { useCallback } from 'react';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { useCurrentTaskEntryId } from '../hook.entry.js';
import { useGoToTaskMutation } from '../mutations/task.go-to.js';
import { useFinishAction } from './finish.js';

function useGoToNextTaskAction(args) {
  const component = useOpgavekompleksetComponent();
  const activeTaskId = useCurrentTaskEntryId();
  const goToTaskMutation = useGoToTaskMutation();
  const finishAction = useFinishAction({
    skipModal: args?.skipFinishModal
  });
  return useCallback(async () => {
    const currentTaskIndex = component.data.tasks.findIndex(it => it.id === activeTaskId);
    const nextTaskIndex = currentTaskIndex + 1;
    const nextTask = component.data.tasks[nextTaskIndex];
    if (nextTask) {
      goToTaskMutation(nextTask.id);
    } else {
      finishAction();
    }
  }, [activeTaskId, component.data.tasks, finishAction, goToTaskMutation]);
}

export { useGoToNextTaskAction };
//# sourceMappingURL=task.go-to-next.js.map
